/** @jsxImportSource @emotion/react */
import { css, useTheme } from '@emotion/react'
import React, {useContext} from 'react'
import { ThemeUI } from '../../../theme'
import { Button, Card, Text } from '../../atoms'
import { ContentSection } from '../../organisms'
import * as styles from './index.styles'
import {Context} from "../../../context/NewContext";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import {useParams} from "react-router";
import {create_news} from "../../../redux/actions/news/create_news";
import {update_news} from "../../../redux/actions/news/update_news";

const NewPreview: React.FC = () => {
  const theme = useTheme() as ThemeUI
  const { formData } = useContext(Context)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const APP_URL = process.env.REACT_APP_URL
  const token = useSelector((state: any) => state.login.access)
  let { idNews } = useParams();
  const handleSubmit = (token: any, formData: any) => {
    if (idNews) {
      if (formData.image !== undefined) {
        if (!formData.image?.name) {
          formData.image = formData.image.indexOf('/media/')>-1 ? undefined : formData.image
        }
      } else {
        formData.image = undefined
      }
      dispatch(update_news({ token, formData, navigate }))
    } else {
      dispatch(create_news({ token, formData, navigate }))
    }
  }

  return (
    <ContentSection
      style={styles.root}
      header={
        <Text textType='p' weight='bold'>Vista Previa</Text>
      }
    >
      <div css={(theme: any) => styles.preview(theme)}>
        <Card style={css({ overflow: 'hidden' })}>
          <Text textType='sm' style={styles.previewTitle(theme)}>
            {formData.title}
          </Text>
          <img
            src={formData.image ? (formData.image?.name ? URL.createObjectURL(formData.image): APP_URL+''+formData.image) : 'https://via.placeholder.com/300x200'}
            alt='placeholder'
            css={styles.previewImage}
          />
          <div css={styles.previewDescription(theme)}>
            <Text textType='sm' weight='light'>
              {formData.description}
            </Text>
          </div>
        </Card>
      </div>
      <Button onClick={() => handleSubmit(token, formData)} disabled={!formData.title || !formData.image}>
        {!idNews ? 'Publicar' : 'Guardar'} noticia
      </Button>
    </ContentSection>
  )
}


export default NewPreview
